var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"part-side-bar"}},_vm._l((_vm.menus),function(item,i){return _c('menuItem',{key:i,attrs:{"item":item,"level":0,"activeMenu":_vm.activeMenu,"indexMenun":i,"allLength":_vm.menus.length}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }